import { Injectable } from '@angular/core';
import { BcKeyboardService } from './keyboard.service';
import { RxEmitter } from '../rxjs/rx-emitter';
import { MessageBusEvents } from '../common/constants/message-bus-events';
import { KeyboardCombos } from '../common/constants/keyboard-combos';

@Injectable({
  providedIn: 'root'
})
export class GlobalKeyboardShortcutsService {
  constructor(private _keyboardService: BcKeyboardService,
              private _rxEmitter: RxEmitter) {
  }

  registerGlobalKeyboardShortcuts(): void {
    this._createGlobalSubscriptions();
  }

  registerGlobalKeyboardShortcutsToElement(element: HTMLElement): void {
    this._createGlobalSubscriptions(element);
  }

  private _createGlobalSubscriptions(element?: HTMLElement) {
    this._bindComboToTopic(KeyboardCombos.CtrlAltI, MessageBusEvents.TraverseWorkItemUp, element);
    this._bindComboToTopic(KeyboardCombos.CtrlAltK, MessageBusEvents.TraverseWorkItemDown, element);
    this._bindComboToTopic(KeyboardCombos.CtrlAltJ, MessageBusEvents.TraverseWorkItemLeft, element);
    this._bindComboToTopic(KeyboardCombos.CtrlAltL, MessageBusEvents.TraverseWorkItemRight, element);
    this._bindComboToTopic(KeyboardCombos.CtrlAltM, MessageBusEvents.ToggleExpandedMode, element);
    this._bindComboToTopic(KeyboardCombos.CtrlAltN, MessageBusEvents.ToggleVisitorInformation, element);
    this._bindComboToTopic(KeyboardCombos.CtrlAltH, MessageBusEvents.OpenSettingsMenu, element);
  }

  private _bindComboToTopic(keyboardCommand: string, topic: string, element: HTMLElement) {
    const options = { stopEvent: true };
    const keyBoardEventCallback = data => {
      this._rxEmitter.send(topic, data);
    };

    if (!element) {
      this._keyboardService.bindGlobal(keyboardCommand, keyBoardEventCallback, options);
    } else {
      this._keyboardService.bindToElement(keyboardCommand, keyBoardEventCallback, element, options);
    }
  }
}
